// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";

interface ImageObject {
    fluid?: { src: string };
    fixed?: { src: string };
    file?: { url: string };
}
interface ImageProps {
    image: ImageObject;
    className?: string;
    alt?: string;
}

export default function Image({ image, className, alt = "" }: ImageProps): React.DOMElement {
    if (image.gatsbyImageData) {
        return <GatsbyImage className={className} image={image.gatsbyImageData} alt={alt} />;
    } else if ("fluid" in image && image.fluid !== null) {
        return <img className={className} src={image.fluid.src} alt={alt} />;
    } else if ("fixed" in image && image.fixed !== null) {
        return <img className={className} src={image.fixed.src} alt={alt} />;
    } else if ("file" in image && image.file !== null) {
        return <img className={className} src={image.file.url} alt={alt} />;
    }
    return null;
}

Image.propTypes = {
    className: PropTypes.string,
    image: PropTypes.object,
};
